// extracted by mini-css-extract-plugin
export var banner = "_i7-0";
export var closeButton = "_i7-2";
export var greenCheckmark = "_i7-3";
export var hereLink = "_i7-4";
export var titleIcon = "_i7-1";